<template>
    <b-container class="h-100">
        <b-row fluid="md" align-v="center" class="h-100">
            <b-col cols="12" v-if="respuestaSif == '00'">
                <b-row class="mh-100vh">
                    <b-col offset-md="3" md="6" class="mb-3 mt-5">
                        <b-img src="/imagenes/carga-tu-bip-en-movired-2023.png" alt="Logo Movired" class="logo mb-3" center
                            height="100" />
                    </b-col>
                    <b-col offset-md="3" md="6" class="mb-3">
                            <h5 class="text-center mb-2 text-bold">¡Carga exitosa!</h5>
                            <h6 class="text-center py-4">Enviamos el comprobante de tu compra al correo electrónico</h6>
                    </b-col>
                    <b-col offset-md="3" md="6">
                        <h5 class="text-left mb-0 pb-0 text-bold" style="margin-bottom: 10px !important;">Detalle de la compra</h5>
                    </b-col>
                    <b-col offset-md="3" md="6" v-if="miClub && status == 200" class="mb-3">
                        <p class="mt-3 text-center mb-0">
                            Por esta recarga acumulaste Pesos Mi Club de Lider.
                        </p>
                        <p class="text-center">
                            ¿Aún no eres parte del mundo de beneficios Mi Club?
                        </p>
                        <a href="https://www.miclublider.cl/register"
                            class="btn btn-info btn-lg rounded-pill mt-1 py-2 btn-block" target="_blank"
                            rel="noopener noreferrer" style="background-color: #0071dc !important;">Inscríbete en Mi
                            Club de Lider</a>
                    </b-col>
                    <b-col offset-md="3" md="6" v-if="miClub && status == 401" class="mb-3">
                        <p class="mt-3 text-center mb-0">
                            ¡Lo lamentamos! No puedes acumular pesos Mi Club con el RUT
                        </p>
                        <p class="text-center">
                            ingresado, por favor revisa nuestros requisitos para acumular.
                        </p>
                        <a href="https://www.miclublider.cl/faqs"
                            class="btn btn-info btn-lg rounded-pill mt-1 py-2 btn-block" target="_blank"
                            rel="noopener noreferrer" style="background-color: #0071dc !important;">Ver requisitos</a>
                    </b-col>
                    <b-col offset-md="3" md="6" class="pt-0">

                        <div class="d-flex justify-content-between borde-confirmacion">
                            <div class="text-left texto-izquierda">
                                {{
                                    productoCodigo == 35 ? 'Tarjeta bip!' :
                                    'RUT bip! QR'
                                }}
                            </div>
                            <div class="text-right text-bold">{{
                                nroTarjetaBip ? nroTarjetaBip : nroTarjetaBip
                            }}</div>
                        </div>
                        <div class="d-flex justify-content-between borde-confirmacion">
                            <div class="text-left texto-izquierda">
                                Monto
                            </div>
                            <div class="text-right text-bold">
                                {{
                                    new Intl.NumberFormat('es-CL', {
                                        currency:
                                            'CLP', style:
                                            'currency'
                                    }).format(monto)
                                }}
                            </div>
                        </div>
                        <div class="borde-confirmacion">
                            <div class="text-left texto-izquierda w-100">
                                Correo electrónico
                            </div>
                            <div class="text-right text-bold w-100">
                                {{ correo }}
                            </div>
                        </div>
                        <div class="d-flex justify-content-between borde-confirmacion">
                            <div class="text-left texto-izquierda">
                                N° transacción
                            </div>
                            <div class="text-right text-bold">
                                {{
                                    transaccionId
                                }}
                            </div>
                        </div>

                    </b-col>

                    <b-col offset-md="3" md="6" class="pt-4 text-center" v-if="productoCodigo == '35'"><h6 class="texto-totem"><b-icon-exclamation-circle-fill
                            variant="success" class="success-metro"></b-icon-exclamation-circle-fill>
                                Recuerda <b>ACTIVAR</b> las cargas de tarjeta bip! en App Red con el NFC de tu celular, Infobip! o totém de Metro.</h6>
                    </b-col>

                </b-row>
            </b-col>
            <b-col cols="12" v-if="respuestaSif != '00'">
                <b-row>
                    <b-col offset-md="3" md="6" class="mb-3">
                        <b-img src="/imagenes/carga-tu-bip-en-movired-2023.png" alt="Logo Movired" class="logo mb-3" center
                            height="100" />
                    </b-col>
                    <b-col offset-md="3" md="6">
                        <b-card class="shadow-lg p-3 mb-5 bg-white rounded">
                            <b-img src="/imagenes/rojo.png" alt="Logo Movired" class="logo mb-3" center height="100" />
                            <h6 class="text-center titulo text-bold mb-3">
                                ¡Algo salió mal!
                            </h6>
                            <h6 class="text-center titulo text-bold">
                                Tu compra no pude ser realizada. <br>
                                ¿Lo volvemos a intentar?
                            </h6>
                        </b-card>
                    </b-col>
                </b-row>
            </b-col>
            <b-col offset-md="3" md="6" class="mt-4 text-center mb-5" v-if="respuestaSif == '00'">

            </b-col>
            <b-col offset-md="3" md="6" class="mt-4 text-center mb-5" v-if="respuestaSif == '00'">
                <b-button size="lg" variant="danger" pill class="py-2 mw-200 button-movired-color" @click="redirigir(productoClientesId)">{{
                respuestaSif == '00' ? 'Realizar otra recarga' : '¡Volverlo a intentar!'}}</b-button>
            </b-col>
        </b-row>
    </b-container>

</template>

<script>
import { BRow, BCol, BContainer, BCard, BIconCircleFill, BTableSimple, BTr, BTd, BButton, BImg, BIconExclamationCircleFill} from 'bootstrap-vue';
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
    props: {
        nroTarjetaBip: String,
        transaccionId: String,
        monto: Number,
        correo: String,
        respuestaSif: String,
        productoNombre: String,
        productoCodigo: String,
        miClub: String,
        status: String,
        productoClientesId:String
    },
    components: {
        BRow,
        BCol,
        BContainer,
        BCard,
        BIconCircleFill,
        BTableSimple,
        BTr,
        BTd,
        BButton,
        BImg,
        BIconExclamationCircleFill
    },
    computed: {
        ...mapState('configuracion', ["configuracionCliente"])
    },
    name: "estado-pago-dinamico",
    methods: {
        ...mapActions(["resetearDatos"]),
        ...mapMutations(["bloquearFalse"]),
        redirigir(prod) {
            this.resetearDatos()
           // alert(prod);

            if (prod == 118 || prod == 119 || prod == 120) {
                window.location.replace('https://www.metro.cl/el-viaje/carga-bip')
            } else if (prod == 128 || prod == 129 || prod == 130) {
                window.location.replace('https://movired.cl/metro/app')
            } else {
                window.location.replace('https://movired.cl')
            }

            //window.location.replace(this.configuracionCliente && this.configuracionCliente.navigation_url ? this.configuracionCliente.navigation_url : '/')
        }
    },
    mounted() {

    },
};
</script>

<style>
.text-color-lider {
    color: #0071dc;
}

@import "~bootstrap/dist/css/bootstrap.css";

.table-sm th,
.table-sm td {
    word-break: break-word !important;
}

@font-face {
    font-family: bariol;
    font-display: swap;
    src: url("../../../../../public/fonts/bariol/bariol_regular-webfont.woff2") format("woff2"),
        url("../../../../../public/fonts/bariol/bariol_regular-webfont.woff") format("woff");
}

table {
    font-weight: text-bold;
}

body,
.fondo-tr {
    background-color: #eaeaea;
    font-family: bariol !important;
    font-size: 1.25rem !important;
    color: #333;
}

.titulo {
    font-size: 1.5rem !important;
}

.container {
    height: 100vh;
    background-color: white;
}

.text-bold {
    font-weight: bold !important;
}

.mw-200 {
    min-width: 200px;
}

.button-movired-color {
    background-color: #c30030;
    border-color: #c30030;
    color: #fff;
}

.button-movired-color:hover {
    background-color: #000;
    border-color: #000;
    color: #fff;
}

.button-movired-color:active {
    background-color: #000 !important;
    border-color: #000 !important;
    color: #fff !important;
}
</style>

